import React from 'react'
import ReactDOM from 'react-dom'
  
export const renderModal = (message, clickHandler) => {
  const placeholder = document.querySelector("#modalPlaceholder")
  ReactDOM.render(<CamperAppModal 
    message={message} 
    clickHandler={clickHandler} 
  />, placeholder)
}


const CamperAppModal = ({message, clickHandler}) => {

  const closeModal = () => {
    ReactDOM.unmountComponentAtNode(document.querySelector('#modalPlaceholder'));
    clickHandler();
  }

  return (
    <div className="CamperAppModal">
      <div className="modal-container">
        <h2>{message}</h2>
        <button onClick={closeModal}>
          <span>OK</span>
        </button>
      </div>
    </div>
  );
};
